import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { ToastrService } from 'ngx-toastr';
import { BusinessAuthService } from '@app/business-portal/business-portal-services/business.auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _tokenService: TokenService,
    private router: Router,
    private _toast: ToastrService,
    private businessAuthService: BusinessAuthService,
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // R24: a 401 on the refresh call itself must not start another refresh (refresh → 401 →
        // refresh → … would loop); it is simply an error, handled by whoever asked for the refresh.
        if (err.status === 401 && request.url.includes('/auth/getAccessToken')) {
          return throwError(() => err);
        }
        if (err.status === 401) {
          const isBusinessPortal = location.pathname.startsWith('/business-portal/');
          const accessTokenKey = 'businessportalAccessToken';
          const refreshTokenKey = 'businessportalRefreshToken';
          const navigateTo = '/business-portal/login';
          const refreshToken = this._tokenService.getTokens().businessportalRefreshToken || '';
          return this.businessAuthService.getAccessToken(refreshToken).pipe(
            switchMap((response) => {
              if (response.status) {
                this._tokenService.setToken(response.data.tokenData.accessToken, accessTokenKey);
                this._tokenService.setToken(response.data.tokenData.refreshToken, refreshTokenKey);
                const clonedRequest = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${response.data.tokenData.accessToken}`,
                  },
                });
                return next.handle(clonedRequest);
              } else {
                this._toast.error(response.message);
                this.router.navigate([navigateTo]);
                return throwError(response.message);
              }
            }),
            catchError((error) => {
              this._toast.error(error);
              isBusinessPortal ? this.businessAuthService.logout() : this.businessAuthService.logout();
              this.router.navigate([navigateTo]);
              return throwError(error);
            }),
          );
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      }),
    );
  }
}
